import { Component, Renderer } from '@angular/core';
import { InformationHttpService } from '../../../services/information/information.http.service';
import { ArrearsHttpService } from '../../../services/arrears/arrears.http.service';
import { ReportHttpService } from '../../../services/report/report.http.service';
import { DashboardHttpUtil } from '../dashboard.util';
import { StorageUtil } from '../../../utils/storage.util';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AuthUtil } from '../../../utils/auth.utils';
import {DevelopUtil} from '../../../utils/develop.utils';
import { environment } from '../../../../environments/environment';

@Component({
  moduleId: module.id,
  templateUrl: 'main.component.html',
  providers: []
})

export class MainComponent {

  model: any = {};

  arrearsModel = [];
  arrearsModelTotal = {arrears:0};

  arrearsStatusOpen: boolean = false;

  pageLoading: boolean = true;
  errorMessage: string;
  serverValidationErrorMessage: any;
  settings: any = {};

  constructor(private informationHttpService: InformationHttpService,
              private arrearsHttpService: ArrearsHttpService,
              private reportHttpService: ReportHttpService,
              private router: Router,
              private authUtil: AuthUtil,
              private renderer: Renderer) {
    this.getInformation();
    this.getArrears();

    this.settings = environment;
  }

  getInformation() {
    let requestParams = DashboardHttpUtil.prepareTokenParam(StorageUtil.getToken());
    requestParams.append('showHistory', "0");

    this.informationHttpService.getInfo(requestParams).subscribe(
      success => {
        if (success) {
          //TODO: loading two request
          this.pageLoading = false;
          let data = success.json();
          if(this.authUtil.checkErrorResponse(data)) {
            this.model = data.response && data.response.items || [];
          }
        }
      },
      error => {
        if (error.status === 422) {
          //TODO: added concat
          this.serverValidationErrorMessage = error.json().errors;
        } else {
          this.errorMessage = 'Произошла ошибка.';
        }
        this.pageLoading = false;
      },
      () => {
        this.pageLoading = false;
      });
  }

  getArrears() {
    let requestParams = DashboardHttpUtil.prepareTokenParam(StorageUtil.getToken());
    this.arrearsHttpService.getArrears(requestParams).subscribe(
      success => {
        if (success) {
          //TODO: loading two request
          // this.pageLoading = false;
          let data = success.json();
          if(this.authUtil.checkErrorResponse(data)) {
            this.arrearsModel = data.response.items || [];
            this.arrearsModelTotal.arrears = this.arrearsModel.filter(it => it&&it.arrears&&it.arrears.arrearsFinesAmount)
                                                              .map(it => this.parseFloatIfString(it.arrears.arrearsFinesAmount))
                                                              .reduce((a,b) => ((a?a : 0) + (b ? b : 0)));
            this.pageLoading = false;
          }
        }
      },
      error => {
        if (error.status === 422) {
          //TODO: added concat
          this.serverValidationErrorMessage = error.json().errors;
        } else {
          this.errorMessage = 'Произошла ошибка.';
        }
        this.pageLoading = false;
      },
      () => {
        this.pageLoading = false;
      });
  }

  getDebtInvoice(): void {
    const requestParams = DashboardHttpUtil.prepareTokenParam(StorageUtil.getToken());
    window.open(DevelopUtil.url('report/debtInvoice?' + requestParams.toString()), '_blank');
  }

  toggleArrearsStatus($event) {
    $event.preventDefault();
    this.arrearsStatusOpen = !this.arrearsStatusOpen;
  }

  toggleNotificationOpen(item) {
      item.isOpen = !item['isOpen'];
      if(!item['read']) {
          item.read = true;

          let requestParams = DashboardHttpUtil.prepareTokenParam(StorageUtil.getToken());
          this.informationHttpService.setRead(requestParams, item.id.toString()).subscribe(() => {});
      }
  }

  navigateToSingleContact(id) {
    this.router.navigate(['/contracts/' + id + '/accruals']);
  }



  formatPrice(price) {
    if ((typeof price) === "string") {
      price = parseFloat(price)
    }
    if (price > 0) {
      return price;
    } else {
      return parseFloat(String(price).replace('-', ''));
    }
  }

  parseFloatIfString(value) {
    if ((typeof value) === "string") {
      return parseFloat(value);
    } else {
      return value;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/main/main.component.ts